import { Type } from "class-transformer";
import { User } from "../user/user.model";

export class RCFeedback {
  id: number;
  createdAt: string;
  feedback: string;
  @Type(() => User)
  user: User;
}
